<template>
    <div
        class="container-fluid weeducAdminCourse weeduc-admin-course-view page-card edit-course-view-page text-left"
    >
        <header class="edit-course-view-header" aria-label="Cabeçalho do curso">
            <div class="edit-course-view-header__primary">
                <div
                    class="title-banner-course edit-course-view-header__thumb"
                >
                    <img
                        :src="courseThumbSrc"
                        :alt="coursePageTitle"
                    />
                    <span
                        class="status-flag"
                        :class="
                            currentCollections.status == 1 ? 'active' : 'inactive'
                        "
                    >
                        {{ currentCollections.status == 1 ? 'Ativo' : 'Inativo' }}
                    </span>
                </div>
                <div class="edit-course-view-header__copy">
                    <TitlePage
                        :title="coursePageTitle"
                        :subtitle="coursePageSubtitle"
                        :hasMargin="false"
                    />
                    <div class="edit-course-view-header__meta">
                        <small class="edit-course-view-id"
                            >Id: {{ currentCollections.id }}</small
                        >
                        <div class="infoCollectionStats">
                            <div
                                class="statsRow clickable-stats"
                                @click="goToMatriculasReport"
                            >
                                <fa icon="fa-users" />
                                <p class="text d-none d-md-block">
                                    Total de matrículas
                                </p>
                                <strong class="text">{{
                                    infoCount.totalEnrols
                                }}</strong>
                            </div>
                            <div class="statsRow">
                                <fa icon="fa-dollar-sign" />
                                <p class="text d-none d-md-block">Faturamento</p>
                                <strong class="text">
                                    {{
                                        infoCount.invoicing
                                            ? infoCount.invoicing.toLocaleString(
                                                  'pt-BR',
                                                  {
                                                      style: 'currency',
                                                      currency: 'BRL',
                                                  }
                                              )
                                            : 'N/A'
                                    }}
                                </strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="edit-course-view-header__actions">
                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="lg"
                    class="text-none"
                    @click="openDialogMatricularAluno"
                >
                    <v-icon class="me-1" size="small">mdi-account-school</v-icon>
                    Nova matrícula
                </v-btn>
                <v-btn
                    variant="outlined"
                    color="primary"
                    rounded="lg"
                    class="text-none"
                    @click="editarCurso"
                >
                    <v-icon class="me-1" size="small">mdi-pencil</v-icon>
                    Editar curso
                </v-btn>
            </div>
        </header>

        <div class="edit-course-view-shell">
            <section class="edit-course-view-stats" aria-label="Métricas de conteúdo">
                <article class="edit-course-view-stat-card">
                    <div class="edit-course-view-stat-card__icon" aria-hidden="true">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                fill="currentColor"
                                d="M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 144c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
                            />
                        </svg>
                    </div>
                    <div class="edit-course-view-stat-card__body">
                        <span class="edit-course-view-stat-card__label"
                            >Tempo estimado</span
                        >
                        <strong class="edit-course-view-stat-card__value">
                            {{ infoCount.timeTotal }}
                            <span class="edit-course-view-stat-card__unit">min</span>
                        </strong>
                    </div>
                </article>
                <article class="edit-course-view-stat-card">
                    <div class="edit-course-view-stat-card__icon" aria-hidden="true">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                fill="currentColor"
                                d="M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.7-256L208 329.7l0-147.5L328.7 256zM212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"
                            />
                        </svg>
                    </div>
                    <div class="edit-course-view-stat-card__body">
                        <span class="edit-course-view-stat-card__label">Vídeos</span>
                        <strong class="edit-course-view-stat-card__value">{{
                            infoCount.totalVideos
                        }}</strong>
                    </div>
                </article>
                <article class="edit-course-view-stat-card">
                    <div class="edit-course-view-stat-card__icon" aria-hidden="true">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512"
                        >
                            <path
                                fill="currentColor"
                                d="M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"
                            />
                        </svg>
                    </div>
                    <div class="edit-course-view-stat-card__body">
                        <span class="edit-course-view-stat-card__label"
                            >Materiais</span
                        >
                        <strong class="edit-course-view-stat-card__value">{{
                            infoCount.totalDocuments
                        }}</strong>
                    </div>
                </article>
                <article class="edit-course-view-stat-card">
                    <div class="edit-course-view-stat-card__icon" aria-hidden="true">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                fill="currentColor"
                                d="M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 120.3 27.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 280.3 27.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L208 80c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM160 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                            />
                        </svg>
                    </div>
                    <div class="edit-course-view-stat-card__body">
                        <span class="edit-course-view-stat-card__label"
                            >Questionários</span
                        >
                        <strong class="edit-course-view-stat-card__value">{{
                            infoCount.totalQuizes
                        }}</strong>
                    </div>
                </article>
            </section>

            <div class="edit-course-view-list-panel">
                <div class="edit-course-view-list-panel__head">
                    <h2 class="edit-course-view-list-panel__title">
                        Módulos e aulas
                    </h2>
                    <p class="edit-course-view-list-panel__lead">
                        Pesquise, reordene por arrastar e crie novas atividades por
                        módulo.
                    </p>
                </div>
                <div class="edit-course-view-toolbar">
                    <div class="edit-course-view-toolbar__controls">
                        <v-text-field
                            type="text"
                            v-model="searchTerm"
                            label="Buscar módulos"
                            placeholder="Nome do módulo..."
                            variant="outlined"
                            hide-details
                            density="compact"
                            class="inputd edit-course-view-v-field flex-grow-1"
                            append-inner-icon="mdi-magnify"
                            clearable
                        />
                        <v-btn
                            variant="flat"
                            color="primary"
                            rounded="lg"
                            :height="$vuetify.display.xs ? '40' : '40'"
                            :icon="$vuetify.display.xs"
                            class="text-none"
                            @click="openNewModuleDialog"
                        >
                            <template v-if="$vuetify.display.xs">
                                <v-icon>mdi-plus</v-icon>
                            </template>
                            <template v-else>
                                <v-icon class="me-1" size="small">mdi-plus</v-icon>
                                Novo módulo
                            </template>
                        </v-btn>
                    </div>
                </div>

                <div class="edit-course-view-modules-wrap">
        <draggable
            :list="filteredModules"
            :disabled="false"
            class="list-group"
            ghost-class="ghost"
            @start="dragging = true"
            @end="onDragEnd"
            handle=".drag-handle"
        >
            <template #item="{ element }">
                <div class="table-modules">
                    <div
                        class="title-table"
                        @click="element.isOpen = !element.isOpen"
                    >
                        <div class="module-header">
                            <div class="drag-handle">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 448 512"
                                    fill="currentColor"
                                >
                                    <path
                                        d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zm0 160c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                                    />
                                </svg>
                            </div>
                            {{ element.title }}
                            <span class="lesson-count"
                                >({{ element.lessons.length }} atividades)</span
                            >
                        </div>
                        <div class="module-actions">
                            <div
                                @click.stop="
                                    openModalEditModule(
                                        element.id,
                                        element.title
                                    )
                                "
                                class="btn-action"
                            >
                                <fa icon="fa fa-pencil" />
                            </div>
                            <div class="dropdown" @click.stop>
                                <button
                                    class="btn-action dropdown-toggle"
                                    @click.stop="toggleDropdown(element)"
                                >
                                    <fa icon="fa-solid fa-plus" />
                                    <span class="info-text-min"
                                        >Nova Atividade</span
                                    >
                                </button>
                                <div
                                    class="dropdown-content"
                                    v-show="element.showDropdown"
                                    v-click-outside="
                                        () => (element.showDropdown = false)
                                    "
                                    :id="element.id"
                                >
                                    <div class="dropdown-item">
                                        <router-link
                                            to="/dashboard/novo-video"
                                            @click.stop="
                                                storeCurrentModuleLocal(element)
                                            "
                                        >
                                            <fa :icon="getLessonIcon(3)" />
                                            Vídeo
                                        </router-link>
                                    </div>
                                    <div class="dropdown-item">
                                        <router-link
                                            to="/dashboard/novo-arquivo"
                                            @click.stop="
                                                storeCurrentModuleLocal(element)
                                            "
                                        >
                                            <fa :icon="getLessonIcon(4)" />
                                            Arquivo PDF
                                        </router-link>
                                    </div>
                                    <div class="dropdown-item">
                                        <router-link
                                            to="/dashboard/quiz"
                                            @click.stop="
                                                storeCurrentModuleLocal(element)
                                            "
                                        >
                                            <fa :icon="getLessonIcon(5)" />
                                            Questionário
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="btn-action">
                                <fa
                                    :icon="
                                        element.isOpen
                                            ? 'fa-chevron-up'
                                            : 'fa-chevron-down'
                                    "
                                />
                            </div>
                        </div>
                    </div>

                    <draggable
                        v-show="element.isOpen"
                        :list="element.lessons"
                        :disabled="false"
                        ghost-class="ghost"
                        @start="draggingLesson = true"
                        @end="onDragEndLesson(element.id)"
                        handle=".drag-handle"
                        class="list-lessons"
                        item-key="id"
                    >
                        <template #item="{ element: lesson }">
                            <div class="lesson-row" :key="lesson.id">
                                <div class="lesson-content">
                                    <div class="drag-handle">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 448 512"
                                            fill="currentColor"
                                        >
                                            <path
                                                d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zm0 160c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zm448 160c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                                            />
                                        </svg>
                                    </div>
                                    <span class="lesson-content-sep">|</span>
                                    <span class="lesson-icon">
                                        <fa
                                            :icon="getLessonIcon(lesson.type)"
                                        />
                                    </span>
                                    <span> </span>
                                    {{ lesson.title }}
                                </div>
                                <div
                                    @click="openModalEdit(lesson)"
                                    class="btn-action"
                                >
                                    <fa icon="fa fa-pencil" />
                                </div>
                                <div
                                    class="btn-action"
                                    @click="openModalDelete(lesson)"
                                >
                                    <fa icon="fa fa-trash" />
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </template>
        </draggable>
                </div>

                <!-- Mensagem caso não haja módulos -->
                <div
                    class="pa-4 text-center"
                    v-if="filteredModules.length === 0 && hasReady"
                >
                    <div
                        class="no-modules-message"
                        style="padding: 40px 20px; text-align: center"
                    >
                        <p
                            style="
                                font-size: 18px;
                                color: #6b7280;
                                margin-bottom: 8px;
                                font-weight: 500;
                            "
                        >
                            Crie seu primeiro módulo
                        </p>
                        <p style="font-size: 14px; color: #9ca3af; margin: 0">
                            Clique no botão "Novo módulo" acima para começar
                        </p>
                    </div>
                </div>

                <!-- Mensagem caso não haja vídeos -->
                <div class="noVideos" v-if="videos?.length === 0 && hasReady">
                    <p>
                        Envie novos videos para esta coleção clicando aqui
                        <fa
                            icon="fa-plus"
                            @click="() => this.$router.push(`/admin/novo-video`)"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- Diálogos e Loaders -->
        <div class="pa-4 text-center">
            <v-dialog v-model="deleteItem" max-width="320" persistent>
                <v-card>
                    <v-card-title class="headline">Atenção</v-card-title>
                    <v-card-text>
                        Deseja realmente excluir o vídeo {{ nameItem }}?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="cancel" text @click="closeDialog"
                            >Não</v-btn
                        >
                        <v-btn class="accept" text @click="closeDialog"
                            >Sim</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <Loader :hasReady="hasReady" />
        <CreateModule :show="true" />
        <CreateLesson :show="true" />

        <!-- Diálogo Novo Módulo -->
        <v-dialog
            v-model="newModuleDialog"
            class="new-module-dialog"
            :max-width="480"
        >
            <v-card class="modal-card">
                <v-card-title class="new-module-title"
                    >Criar Novo Módulo</v-card-title
                >
                <v-card-text>
                    <v-text-field
                        v-model="newModuleTitle"
                        label="Título do Módulo"
                        required
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="new-module-actions">
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="newModuleDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1"
                        color="primary"
                        variant="flat"
                        @click="createNewModule"
                        :disabled="newModuleTitle.length === 0"
                        >Criar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo Editar Módulo -->
        <v-dialog
            v-model="editModuleDialog"
            class="edit-module-dialog"
            :max-width="480"
        >
            <v-card class="modal-card">
                <v-card-title class="edit-module-title"
                    >Editar Módulo</v-card-title
                >
                <v-card-text>
                    <v-text-field
                        v-model="editModuleTitle"
                        label="Título do Módulo"
                        required
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="edit-module-actions">
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="editModuleDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1"
                        color="primary"
                        @click="updateModule"
                        :disabled="editModuleTitle.length === 0"
                        >Salvar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo Excluir Módulo/Aula -->
        <v-dialog v-model="deleteModuleDialog" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">Excluir Módulo</h3>
                </v-card-title>
                <v-card-subtitle>
                    <p class="mb-0">
                        Tem certeza que deseja excluir este módulo? Esta ação
                        não poderá ser desfeita.
                    </p>
                </v-card-subtitle>
                <v-card-text>
                    <p>
                        Título:
                        <strong>{{ selectedLessonDelete.title }}</strong>
                    </p>
                </v-card-text>
                <v-card-actions class="edit-module-actions">
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="deleteModuleDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1 text-white"
                        color="danger"
                        variant="flat"
                        @click="deleteLesson"
                        >Excluir</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

    <v-dialog
        v-model="dialogMatricularAluno"
        transition="dialog-bottom-transition"
        :max-width="600"
        id="dialogMatricularAluno"
    >
        <v-card class="modal-card">
            <v-card-title>
                <h3>Matricular Aluno</h3>
            </v-card-title>
            <v-card-text>
                <p>Selecione um aluno para realizar a matrícula:</p>

                <div class="student-select-container">
                    <v-autocomplete
                        v-model="alunoSelecionado"
                        :items="listaAlunos"
                        item-title="name"
                        item-value="id"
                        label="Aluno"
                        variant="outlined"
                        density="compact"
                        :disabled="loadingMatricula || showNewUserForm"
                        :loading="loadingAlunos"
                        return-object
                        required
                        :no-data-text="'Nenhum aluno encontrado'"
                        class="flex-grow-1"
                    />

                    <v-btn
                        variant="outlined"
                        color="primary"
                        @click="toggleNewUserForm"
                        :disabled="loadingMatricula"
                        class="new-user-btn ml-2"
                        :icon="$vuetify.display.xs"
                        size="small"
                    >
                        <v-icon>mdi-account-plus</v-icon>
                        <span v-if="!$vuetify.display.xs" class="ml-2">Novo Aluno</span>
                    </v-btn>
                </div>

                <!-- Formulário para novo usuário -->
                <v-expand-transition>
                    <div v-if="showNewUserForm" class="new-user-form mt-4">
                        <v-divider class="mb-4"></v-divider>
                        <h4 class="mb-3">Cadastrar Novo Aluno</h4>
                        
                        <v-form ref="newUserForm" v-model="newUserFormValid">
                            <v-text-field
                                v-model="newUser.name"
                                label="Nome completo"
                                variant="outlined"
                                density="compact"
                                :rules="nameRules"
                                :disabled="loadingMatricula"
                                required
                            ></v-text-field>

                            <v-text-field
                                v-model="newUser.email"
                                label="E-mail"
                                type="email"
                                variant="outlined"
                                density="compact"
                                :rules="emailRules"
                                :disabled="loadingMatricula"
                                required
                            ></v-text-field>

                            <v-text-field
                                v-model="newUser.cpf"
                                label="CPF"
                                variant="outlined"
                                density="compact"
                                :rules="cpfRules"
                                :disabled="loadingMatricula"
                                v-mask="'###.###.###-##'"
                                required
                            ></v-text-field>
                        </v-form>
                    </div>
                </v-expand-transition>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="flex-grow-1 cancel-btn"
                    color="grey-darken-4"
                    variant="tonal"
                    text="Cancelar"
                    @click="closeMatriculaDialog"
                    :disabled="loadingMatricula"
                    id="btnCancelarMatricula"
                ></v-btn>
                <v-btn
                    v-if="!showNewUserForm"
                    class="flex-grow-1"
                    color="primary"
                    variant="flat"
                    text="Matricular"
                    @click="manualEnrol"
                    :loading="loadingMatricula"
                    :disabled="!alunoSelecionado || loadingMatricula"
                ></v-btn>
                <v-btn
                    v-else
                    class="flex-grow-1"
                    color="success"
                    variant="flat"
                    text="Criar e Matricular"
                    @click="createUserAndEnrol"
                    :loading="loadingMatricula"
                    :disabled="!newUserFormValid || loadingMatricula"
                ></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Sesson from '@/utils/Weflix/sesson';
    import Loader from '@/components/Weflix/Loader.vue';
    import ApiModules from '@/utils/modules';
    import ApiLesson from '@/utils/lesson';
    import Courses from '@/utils/courses';
    import { mapState, mapActions } from 'vuex';
    import draggable from 'vuedraggable';
    import { toast } from 'vue3-toastify';
    import clickOutside from '@/directives/click-outside';
    import ApiUser from '@/utils/user';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    export default {
        directives: {
            clickOutside,
        },
        components: {
            Loader,
            draggable,
            TitlePage,
        },
        data() {
            return {
                seasson: [],
                valueProgressTemporary: 0,
                deleteItem: false,
                nameItem: '',
                season: '',
                seasonSelected: null,
                modules: [],
                hasReady: false,
                descriptionCollection: '',
                nameCollection: '',
                totalVideos: 0,
                totalMinutes: 0,
                totalViews: 0,
                dataViewVideos: [],
                manySeason: false,
                dragging: false,
                draggingLesson: false,
                allModulesOpen: true,
                searchTerm: '',
                infoCount: [],
                newModuleDialog: false,
                newModuleTitle: '',
                newModuleDescription: '',
                editModuleDialog: false,
                editModuleTitle: '',
                currentModuleId: null,
                deleteModuleDialog: false,
                selectedLessonDelete: { id: null, title: '' },
                dialogMatricularAluno: false,
                alunoSelecionado: null,
                listaAlunos: [],
                loadingMatricula: false,
                loadingAlunos: false,
                showNewUserForm: false,
                newUserFormValid: false,
                newUser: {
                    name: '',
                    email: '',
                    cpf: ''
                },
                nameRules: [
                    v => !!v || 'Nome é obrigatório',
                    v => (v && v.length >= 2) || 'Nome deve ter pelo menos 2 caracteres'
                ],
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido'
                ],
                cpfRules: [
                    v => !!v || 'CPF é obrigatório',
                    v => this.validateCPF(v) || 'CPF deve ser válido'
                ],
            };
        },
        mounted() {
            const toastMessage = this.$route.query.toast;
            const toastType = this.$route.query.type || 'success';

            if (toastMessage) {
                this.notify(toastMessage, toastType);

                setTimeout(() => {
                    const newQuery = { ...this.$route.query };
                    delete newQuery.toast;
                    delete newQuery.type;
                    this.$router.replace({ query: newQuery });
                }, 3000);
            }
            this.getUserData();
        },
        computed: {
            ...mapState(['token', 'currentCollections', 'currentModule']),
            filteredModules() {
                if (!this.searchTerm) return this.modules;
                const searchLower = this.searchTerm.toLowerCase();
                return this.modules.filter((module) =>
                    module.title.toLowerCase().includes(searchLower)
                );
            },
            coursePageTitle() {
                return (
                    this.currentCollections?.comercialName?.trim() || 'Curso'
                );
            },
            coursePageSubtitle() {
                const plain = this.stripHtmlDescription(
                    this.currentCollections?.shortDescription
                );
                return (
                    plain ||
                    'Gerencie módulos, aulas e matrículas neste curso.'
                );
            },
            courseThumbSrc() {
                const path = this.currentCollections?.imageFinalPath;
                if (path) return path;
                try {
                    return require('@/assets/Weflix/default-video-thumbnail.jpg');
                } catch {
                    return '';
                }
            },
        },
        methods: {
            ...mapActions(['storeCurrentModule']),

            stripHtmlDescription(html) {
                if (!html || typeof html !== 'string') return '';
                return html
                    .replace(/<[^>]*>/g, '')
                    .replace(/\s+/g, ' ')
                    .trim();
            },

            editarCurso() {
                this.$router.push(
                    `/dashboard/form-curso/${this.currentCollections.id}`
                );
            },
            async manualEnrol() {
                const payload = {
                    tokenStudent: this.alunoSelecionado.id,
                    tokenCourse: this.currentCollections.id,
                };
                try {
                    const response = await Courses.manualEnrol(
                        this.token,
                        payload
                    );
                    this.notify(
                        `Aluno ${this.alunoSelecionado.name} matriculado com sucesso`,
                        'success'
                    );
                    this.dialogMatricularAluno = false;
                    this.alunoSelecionado = null;
                    this.getModules();
                } catch (err) {
                    this.notify(
                        'Erro ao matricular aluno. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao matricular aluno:', err);
                }
            },
            storeCurrentModuleLocal(item) {
                this.storeCurrentModule({ currentModule: item });
            },

            openModalDelete(item) {
                this.deleteModuleDialog = true;
                this.selectedLessonDelete = item;
            },

            openNewModuleDialog() {
                this.newModuleDialog = true;
            },

            async createNewModule() {
                const payload = {
                    idCourse: this.currentCollections.id,
                    title: this.newModuleTitle,
                    sample: 0,
                };
                try {
                    await ApiModules.createNewModule(payload, this.token);
                    await this.getModules();
                    this.newModuleDialog = false;
                    this.newModuleTitle = '';
                    this.newModuleDescription = '';
                } catch (error) {
                    this.notify(
                        'Erro ao criar novo módulo. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao criar novo módulo:', error);
                }
            },

            toggleAllModules() {
                this.allModulesOpen = !this.allModulesOpen;
                this.modules.forEach((module) => {
                    module.isOpen = this.allModulesOpen;
                });
            },

            toggleDropdown(element) {
                const isOpen = element.showDropdown;
                // Fecha todos os dropdowns
                this.modules.forEach((m) => (m.showDropdown = false));
                // Se não estava aberto, abre o clicado
                if (!isOpen) {
                    element.showDropdown = true;
                }
            },

            getLessonIcon(type) {
                const icons = {
                    1: 'fa-solid fa-video',
                    2: 'fa-solid fa-video',
                    3: 'fa-solid fa-video',
                    4: 'fa-solid fa-file-pdf',
                    5: 'fa-solid fa-list-check',
                };
                return icons[type];
            },

            deleteVideo(id, name) {
                this.deleteItem = true;
                this.nameItem = name;
            },

            closeDialog() {
                this.deleteItem = false;
            },

            editVideo(id) {
                this.$router.push('/admin/video/' + id);
            },
            openDialogMatricularAluno() {
                this.dialogMatricularAluno = true;
                this.showNewUserForm = false;
                this.resetNewUserForm();
            },
            toggleNewUserForm() {
                this.showNewUserForm = !this.showNewUserForm;
                if (!this.showNewUserForm) {
                    this.resetNewUserForm();
                }
            },
            resetNewUserForm() {
                this.newUser = {
                    name: '',
                    email: '',
                    cpf: ''
                };
                this.newUserFormValid = false;
                this.alunoSelecionado = null;
            },
            closeMatriculaDialog() {
                this.dialogMatricularAluno = false;
                this.showNewUserForm = false;
                this.resetNewUserForm();
            },
            validateCPF(cpf) {
                if (!cpf) return false;
                // Remove caracteres não numéricos
                cpf = cpf.replace(/[^\d]/g, '');
                
                // Verifica se tem 11 dígitos
                if (cpf.length !== 11) return false;
                
                // Verifica se todos os dígitos são iguais
                if (/^(\d)\1{10}$/.test(cpf)) return false;
                
                // Validação do CPF
                let sum = 0;
                for (let i = 0; i < 9; i++) {
                    sum += parseInt(cpf.charAt(i)) * (10 - i);
                }
                let remainder = 11 - (sum % 11);
                if (remainder === 10 || remainder === 11) remainder = 0;
                if (remainder !== parseInt(cpf.charAt(9))) return false;
                
                sum = 0;
                for (let i = 0; i < 10; i++) {
                    sum += parseInt(cpf.charAt(i)) * (11 - i);
                }
                remainder = 11 - (sum % 11);
                if (remainder === 10 || remainder === 11) remainder = 0;
                if (remainder !== parseInt(cpf.charAt(10))) return false;
                
                return true;
            },
            async createUserAndEnrol() {
                if (!this.newUserFormValid) {
                    this.notify('Por favor, preencha todos os campos corretamente.', 'error');
                    return;
                }

                this.loadingMatricula = true;
                
                try {
                    // Primeiro, criar o usuário usando a API
                    const userPayload = {
                        address: "",
                        addressComplement: "",
                        addressNumber: "",
                        birthdate: "",
                        city: "",
                        country: "br",
                        county: "AC",
                        email: this.newUser.email,
                        gender: "",
                        idNumber: "",
                        name: this.newUser.name,
                        neighborhood: "",
                        phone: "",
                        photo: "",
                        postcode: "",
                        socialNumber: this.newUser.cpf.replace(/[^\d]/g, ''), // Remove formatação
                        status: 1,
                        type: 3
                    };

                    console.log('Criando usuário com payload:', userPayload);
                    const userResponse = await ApiUser.CreateUser(this.token, userPayload);
                    console.log('Resposta da criação do usuário:', userResponse);
                    
                    if (userResponse && userResponse.id) {
                        // Aguardar um momento para garantir que o usuário foi criado
                        await new Promise(resolve => setTimeout(resolve, 1000));
                        
                        // Depois, matricular o usuário no curso usando o ID retornado
                        const enrolPayload = {
                            tokenStudent: userResponse.id,
                            tokenCourse: this.currentCollections.id,
                        };

                        console.log('Matriculando usuário com payload:', enrolPayload);
                        const enrolResponse = await Courses.manualEnrol(this.token, enrolPayload);
                        console.log('Resposta da matrícula:', enrolResponse);
                        
                        this.notify(
                            `Usuário ${this.newUser.name} criado e matriculado com sucesso!`,
                            'success'
                        );
                        
                        // Fechar diálogo e atualizar dados
                        this.closeMatriculaDialog();
                        
                        // Atualizar lista de alunos e estatísticas
                        await this.getUserData();
                        await this.getModules();
                        await this.getStatusCourse();
                        
                    } else {
                        throw new Error('Erro ao criar usuário: resposta inválida da API');
                    }
                } catch (err) {
                    console.error('Erro ao criar usuário e matricular:', err);
                    
                    let errorMessage = 'Erro ao criar usuário e matricular. Por favor, tente novamente.';
                    
                    if (err.response && err.response.data) {
                        errorMessage = err.response.data.message || errorMessage;
                    } else if (err.message) {
                        errorMessage = err.message;
                    }
                    
                    this.notify(errorMessage, 'error');
                } finally {
                    this.loadingMatricula = false;
                }
            },
            async getSesson() {
                const param = this.$route.params.slug;
                try {
                    const response = await Sesson.getSessonByCollection(
                        this.token,
                        param
                    );
                    if (response.length > 0) {
                        this.season = response;
                        this.seasonSelected = this.season[0].id;
                        this.manySeason = this.season.length > 1;
                        this.getVideos(this.seasonSelected);
                    } else {
                        await this.newSeason();
                        const newResponse = await Sesson.getSessonByCollection(
                            this.token,
                            param
                        );
                        this.season = newResponse;
                        this.seasonSelected = this.season[0].id;
                        this.manySeason = this.season.length > 1;
                        this.getVideos(this.seasonSelected);
                    }
                } catch (error) {
                    this.notify(
                        'Erro ao obter dados da coleção. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao obter dados da coleção:', error);
                }
            },

            async getModules() {
                try {
                    const response =
                        await ApiModules.getDataModulesAndLessonsByCourse(
                            this.currentCollections.id,
                            this.token
                        );
                    this.modules = response
                        .sort((a, b) => a.order - b.order)
                        .map((module, index) => ({
                            ...module,
                            isOpen: index === 0,
                            showDropdown: false,
                        }));
                    this.hasReady = true;
                } catch (error) {
                    this.notify(
                        'Erro ao processar os módulos. Por favor, tente novamente.',
                        'error'
                    );
                    console.error(error);
                }
            },

            changeSeason() {
                this.hasReady = false;
                this.getVideos(this.seasonSelected);
            },

            async getCourseTypeCount() {
                try {
                    const response = await Courses.getCourseTypeCount(
                        this.token,
                        this.currentCollections.id
                    );
                    this.infoCount = response;
                } catch (error) {
                    console.error('Erro ao obter contadores do curso:', error);
                }
            },

            async onDragEnd() {
                const payload = this.modules.map((module, index) => ({
                    id: module.id,
                    order: index + 1,
                }));
                try {
                    await ApiModules.orderModules(this.token, payload);
                } catch (error) {
                    console.error('Erro ao alterar ordem dos módulos:', error);
                }
            },

            async onDragEndLesson(moduleId) {
                const module = this.modules.find((m) => m.id === moduleId);
                if (!module) return;
                const payload = module.lessons.map((lesson, index) => ({
                    id: lesson.id,
                    order: index + 1,
                }));
                try {
                    await ApiModules.orderLessons(this.token, payload);
                } catch (error) {
                    console.error('Erro ao alterar ordem das lições:', error);
                }
            },

            async getStatusCourse() {
                try {
                    const response = await ApiModules.getStatusCourse(
                        this.token,
                        this.currentCollections.id
                    );
                    this.infoCount = response;
                } catch (error) {
                    console.error('Erro ao pegar status do curso:', error);
                }
            },

            openModalEdit(lesson) {
                if (lesson.type == 5) {
                    this.$router.push(`/dashboard/quiz/${lesson.id}`);
                } else if ([1, 2, 3].includes(lesson.type)) {
                    this.$router.push(`/dashboard/editar-video/${lesson.id}`);
                } else if (lesson.type == 4) {
                    this.$router.push(`/dashboard/editar-arquivo/${lesson.id}`);
                }
            },

            openModalEditModule(moduleId, moduleTitle) {
                this.currentModuleId = moduleId;
                this.editModuleTitle = moduleTitle;
                this.editModuleDialog = true;
            },

            async updateModule() {
                try {
                    const payload = {
                        idCourse: this.currentCollections.id,
                        title: this.editModuleTitle,
                        sample: 0,
                    };
                    await ApiModules.editModule(
                        payload,
                        this.token,
                        this.currentModuleId
                    );
                    await this.getModules();
                    this.editModuleDialog = false;
                    this.notify('Módulo atualizado com sucesso.', 'success');
                } catch (error) {
                    this.notify(
                        'Erro ao atualizar módulo. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao atualizar módulo:', error);
                }
            },

            confirmDeleteModule() {
                this.deleteModuleDialog = true;
            },

            async deleteModule() {
                try {
                    await ApiModules.deleteModule(
                        this.token,
                        this.currentModuleId
                    );
                    await this.getModules();
                    this.deleteModuleDialog = false;
                    this.editModuleDialog = false;
                    this.notify('Módulo excluído com sucesso.', 'success');
                } catch (error) {
                    this.notify(
                        'Erro ao excluir módulo. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao excluir módulo:', error);
                }
            },

            async deleteLesson() {
                try {
                    await ApiLesson.deleteLesson(
                        this.selectedLessonDelete.id,
                        this.token
                    );
                    await this.getModules();
                    this.deleteModuleDialog = false;
                    this.editModuleDialog = false;
                    toast.success('Lição excluída com sucesso!');
                } catch (error) {
                    toast.error(
                        'Erro ao excluir lição: ',
                        error?.message
                            ? error.message
                            : 'Por favor, tente novamente.'
                    );
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
            goToMatriculasReport() {
                // Navega para a aba de relatórios com filtros de matrículas e nome do curso
                this.$router.push({
                    path: '/dashboard/relatorios',
                    query: {
                        filter: 'matriculas',
                        courseName: this.currentCollections.comercialName
                    }
                });
            },
            async getUserData() {
                try {
                    const response = await ApiUser.getAllUser(this.token);
                    this.listaAlunos = response.content
                        .filter(
                            (user) => user.status == 1 && user.name && user.id
                        )
                        .map((user) => ({
                            name: user.name,
                            id: user.id,
                        }));
                } catch (err) {
                    this.notify(
                        'Erro ao carregar dados do Usuário. Por favor, tente novamente.',
                        'error'
                    );
                    console.error('Erro ao carregar dados do Usuário');
                }
            },
        },
        created() {
            this.getModules();
            this.getStatusCourse();
        },
    };
</script>

<style scoped>
    @import url(./global.css);
    @import url('@/css/weeduc/admin/course.css');
    .no-uppercase :deep(.v-btn__content) {
        text-transform: none;
    }

    .edit-course-view-page.weeduc-admin-course-view.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .edit-course-view-header {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem 1.5rem;
        padding: 1.25rem 1.5rem 1.15rem;
        background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
        border-bottom: 1px solid #e8eaf0;
        border-radius: 16px 16px 0 0;
    }

    .edit-course-view-header__primary {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 1rem 1.25rem;
        flex: 1;
        min-width: min(100%, 260px);
    }

    .edit-course-view-header__thumb {
        position: relative;
        flex-shrink: 0;
    }


    .edit-course-view-header__copy {
        flex: 1;
        min-width: min(100%, 200px);
    }

    .edit-course-view-header__copy :deep(.titlelayoutGeneric) {
        border-bottom: none;
        padding-bottom: 0;
    }

    .edit-course-view-header__copy :deep(.titlelayoutGeneric h3) {
        font-size: 1.5rem;
        margin: 0 0 0.35rem;
        color: #1a1d26;
    }

    .edit-course-view-header__copy :deep(.titlelayoutGeneric small) {
        display: block;
        color: #5c6370;
        line-height: 1.45;
    }

    .dashboard.dark .edit-course-view-header__copy :deep(.titlelayoutGeneric h3) {
        color: #f1f3f7;
    }

    .dashboard.dark .edit-course-view-header__copy :deep(.titlelayoutGeneric small) {
        color: #9ca3b4;
    }

    .edit-course-view-header__meta {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.65rem 1rem;
        margin-top: 0.65rem;
    }

    .edit-course-view-header__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.75rem;
        flex-shrink: 0;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-header__actions .v-btn--variant-outlined {
        background: transparent !important;
        color: #ffffff !important;
        border: 1px solid rgba(255, 255, 255, 0.72) !important;
        box-shadow: none !important;
    }

    .dashboard.dark
        .weeduc-admin-course-view
        .edit-course-view-header__actions
        .v-btn--variant-outlined
        :deep(.v-btn__underlay) {
        opacity: 0;
    }

    .dashboard.dark
        .weeduc-admin-course-view
        .edit-course-view-header__actions
        .v-btn--variant-outlined
        :deep(.v-btn__content),
    .dashboard.dark
        .weeduc-admin-course-view
        .edit-course-view-header__actions
        .v-btn--variant-outlined
        :deep(.v-icon) {
        color: #ffffff !important;
    }

    .dashboard.dark
        .weeduc-admin-course-view
        .edit-course-view-header__actions
        .v-btn--variant-outlined:hover {
        border-color: rgba(255, 255, 255, 0.95) !important;
        background: rgba(255, 255, 255, 0.06) !important;
    }

    .edit-course-view-shell {
        padding: 1.25rem 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .edit-course-view-shell::-webkit-scrollbar {
        display: none;
    }

    .edit-course-view-id {
        display: block;
        font-size: 11px;
        color: #9ca3af;
        font-weight: 500;
        margin-bottom: 0;
        letter-spacing: 0.3px;
        flex-shrink: 0;
    }

    .edit-course-view-stats {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 1rem;
        margin-bottom: 1.25rem;
    }

    @media (max-width: 1199px) {
        .edit-course-view-stats {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    @media (max-width: 575px) {
        .edit-course-view-stats {
            grid-template-columns: 1fr;
        }
    }

    .edit-course-view-stat-card {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem 1.25rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-course-view-stat-card__icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background: #eef0fc;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: #250891;
    }

    .edit-course-view-stat-card__icon svg {
        width: 1.15rem;
        height: 1.15rem;
    }

    .edit-course-view-stat-card__body {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
        min-width: 0;
        text-align: left;
    }

    .edit-course-view-stat-card__label {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: #5c6370;
    }

    .edit-course-view-stat-card__value {
        font-size: 1.35rem;
        font-weight: 700;
        color: #1a1d26;
        line-height: 1.2;
    }

    .edit-course-view-stat-card__unit {
        font-size: 0.875rem;
        font-weight: 600;
        color: #5c6370;
        margin-left: 0.15rem;
    }

    .edit-course-view-list-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.35rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .edit-course-view-list-panel__head {
        margin: 0 0 1rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #f0f2f5;
    }

    .edit-course-view-list-panel__title {
        font-size: 1.0625rem;
        font-weight: 700;
        color: #1a1d26;
        margin: 0 0 0.35rem;
        line-height: 1.3;
    }

    .edit-course-view-list-panel__lead {
        font-size: 0.875rem;
        color: #5c6370;
        line-height: 1.5;
        margin: 0;
    }

    .edit-course-view-toolbar {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        padding: 1rem 1.1rem 1.1rem;
    }

    .edit-course-view-toolbar__controls {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 0.75rem 1rem;
    }

    .edit-course-view-toolbar :deep(.edit-course-view-v-field .v-field) {
        border-radius: 10px;
    }

    .edit-course-view-toolbar :deep(.edit-course-view-v-field .v-field__outline) {
        --v-field-border-opacity: 1;
        color: #e0e2e8;
    }

    .edit-course-view-toolbar
        :deep(.edit-course-view-v-field.v-input--focused .v-field__outline) {
        color: #250891;
    }

    .edit-course-view-modules-wrap {
        margin-top: 1.15rem;
        padding-top: 1.1rem;
        border-top: 1px solid #f0f2f5;
    }

    .weeducAdminCourse .drag-handle svg {
        color: #250891;
    }

    .lesson-content-sep {
        color: #94a3b8;
        user-select: none;
    }

    /* Miniatura e badge (hero) */
    .weeducAdminCourse .title-banner-course {
        width: 160px;
        height: 100px;
        flex-shrink: 0;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        transition: transform 0.2s ease;
    }

    .weeducAdminCourse .title-banner-course:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    }

    .weeducAdminCourse .title-banner-course img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .weeducAdminCourse .edit-course-view-header__thumb.title-banner-course {
        width: 132px;
        height: 84px;
        border-radius: 12px;
    }

    .weeducAdminCourse .status-flag {
        position: absolute;
        bottom: 8px;
        right: 8px;
        padding: 4px 10px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        backdrop-filter: blur(8px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .weeducAdminCourse .status-flag.active {
        background: rgba(16, 185, 129, 0.95);
        color: white;
    }

    .weeducAdminCourse .status-flag.inactive {
        background: rgba(107, 114, 128, 0.95);
        color: white;
    }

    /* Estatísticas (matrículas / faturamento no header) — lado a lado */
    .weeducAdminCourse .infoCollectionStats {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: stretch;
        gap: 10px;
        padding: 0;
        flex: 1;
        min-width: min(100%, 220px);
    }

    .weeducAdminCourse .infoCollectionStats .statsRow {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 14px;
        background: #f9fafb;
        border-radius: 10px;
        transition: all 0.2s ease;
        border: 1px solid transparent;
        flex: 1;
        min-width: 140px;
    }
    
    .weeducAdminCourse .infoCollectionStats .statsRow.clickable-stats {
        cursor: pointer;
    }
    
    .weeducAdminCourse .infoCollectionStats .statsRow.clickable-stats:hover {
        background: #f3f4f6;
        border-color: #e5e7eb;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }
    
    .weeducAdminCourse .infoCollectionStats .statsRow svg {
        width: 18px;
        height: 18px;
        color: #250891;
        flex-shrink: 0;
    }
    
    .weeducAdminCourse .infoCollectionStats .statsRow .text {
        font-size: 12px;
        color: #6b7280;
        margin: 0;
        font-weight: 500;
    }
    
    .weeducAdminCourse .infoCollectionStats .statsRow strong.text {
        font-size: 16px;
        font-weight: 700;
        color: #1f2937;
        margin-left: auto;
    }

    .dashboard.dark .weeducAdminCourse .infoCollectionStats .statsRow {
        background: #2a2d36;
        border-color: #3d414d;
    }

    .dashboard.dark
        .weeducAdminCourse
        .infoCollectionStats
        .statsRow.clickable-stats:hover {
        background: #323643;
        border-color: #392497;
    }

    .dashboard.dark .weeducAdminCourse .infoCollectionStats .statsRow svg {
        color: #b4a9f0;
    }

    .dashboard.dark .weeducAdminCourse .infoCollectionStats .statsRow strong.text {
        color: #f1f3f7;
    }

    .dashboard.dark .weeducAdminCourse .infoCollectionStats .statsRow .text {
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-list-panel {
        background: #23252e;
        border-color: #353945;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.22);
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-list-panel__head {
        border-bottom-color: #353945;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-list-panel__title {
        color: #f8fafc;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-list-panel__lead {
        color: #b4bcc8;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-toolbar {
        background: #1e2128;
        border-color: #3d414d;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-modules-wrap {
        border-top-color: #353945;
    }

    .dashboard.dark .weeducAdminCourse .table-modules {
        background: #2a2d36;
        border: 1px solid #353945;
        border-radius: 12px;
        box-shadow: none;
    }

    .dashboard.dark .weeducAdminCourse .title-table {
        background: transparent;
        border-color: #353945;
    }

    .dashboard.dark .weeducAdminCourse .list-lessons {
        background: #252830;
        border-color: #353945;
    }

    .dashboard.dark .weeducAdminCourse .list-lessons .lesson-row {
        border-bottom-color: #353945;
    }

    .dashboard.dark .weeducAdminCourse .list-lessons .lesson-row:hover,
    .dashboard.dark .weeducAdminCourse .lesson-row:hover {
        background-color: #323643;
    }

    .dashboard.dark .weeducAdminCourse .lesson-count {
        color: #9ca3b4;
    }

    .dashboard.dark .weeducAdminCourse .lesson-content-sep {
        color: #6b7288;
    }

    .dashboard.dark .weeducAdminCourse .drag-handle:hover {
        background: rgba(255, 255, 255, 0.06);
    }

    .dashboard.dark .weeducAdminCourse .drag-handle svg {
        color: #c4b5fd;
    }

    .dashboard.dark .weeducAdminCourse .module-actions > .btn-action:hover svg {
        color: #c4b5fd;
    }

    .dashboard.dark .weeducAdminCourse .lesson-icon {
        color: #b4b9c5;
    }

    .dashboard.dark .weeducAdminCourse .dropdown-content {
        background-color: #2a2d36 !important;
        border: 1px solid #3d414d;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
    }

    .dashboard.dark .weeducAdminCourse .dropdown-content a svg,
    .dashboard.dark .weeducAdminCourse .dropdown-content svg {
        color: #ffffff !important;
    }

    .dashboard.dark .weeducAdminCourse .dropdown-item:hover {
        background-color: #323643 !important;
    }

    @media screen and (max-width: 768px) {
        .edit-course-view-header {
            flex-direction: column;
            align-items: stretch;
        }

        .edit-course-view-header__primary {
            width: 100%;
        }

        .weeducAdminCourse .edit-course-view-header__thumb.title-banner-course {
            width: 100%;
            max-width: 100%;
            height: 160px;
        }

        .edit-course-view-header__meta {
            width: 100%;
            flex-direction: column;
            align-items: stretch;
        }

        .weeducAdminCourse .infoCollectionStats {
            width: 100%;
        }

        .edit-course-view-header__actions {
            width: 100%;
            justify-content: flex-start;
        }
    }

    @media screen and (max-width: 420px) {
        .weeducAdminCourse .infoCollectionStats {
            flex-direction: column;
        }

        .weeducAdminCourse .infoCollectionStats .statsRow {
            width: 100%;
            min-width: 0;
        }
    }

    /* Layout do diálogo de matrícula */
    .student-select-container {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        margin-top: 8px;
    }
    
    .student-select-container .v-autocomplete {
        flex: 1;
    }
    
    .student-select-container .new-user-btn {
        flex-shrink: 0;
        margin-top: 0;
        align-self: flex-start;
        height: 40px;
    }
    
    .student-select-container .v-autocomplete :deep(.v-field) {
        height: 40px;
    }
    
    @media screen and (max-width: 600px) {
        .student-select-container {
            flex-direction: column;
        }
        
        .student-select-container .new-user-btn {
            width: 100%;
            margin-left: 0;
            margin-top: 8px;
        }
    }
</style>

<style>
    /**
     * Dark mode — detalhe do curso (weeduc-admin-course-view / edit-course-view-page)
     */
    .dashboard.dark .weeduc-admin-course-view.edit-course-view-page.page-card {
        background: #1c1d24;
        border: 1px solid #2f323c;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-header {
        background: linear-gradient(145deg, #23252e 0%, #1c1d24 100%);
        border-bottom-color: #353945;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-shell {
        scrollbar-color: #353945 transparent;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-id {
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-stat-card {
        background: #252730;
        border-color: #353945;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-stat-card__icon {
        background: #323643;
        color: #b4a9f0;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-stat-card__label {
        color: #9ca3b4;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-stat-card__value {
        color: #f1f3f7;
    }

    .dashboard.dark .weeduc-admin-course-view .edit-course-view-stat-card__unit {
        color: #9ca3b4;
    }
</style>
